import * as React from 'react'
import { useMemo } from 'react'
import { Checkbox, Text, Tooltip } from '@fluentui/react-components'
import PersonAvatar from '../../components/PersonAvatar'
import { Link } from 'react-router-dom'
import useViewport, { Viewport } from '../../hooks/useViewport'
import { DateFormats } from '../../helpers/dateHelper'
import { useTranslation } from 'react-i18next'
import MoneyText from '../../components/Text/Currency/MoneyText'
import { InvoiceStatusLabels } from '../../components/TagPicker/InvoiceStatusPicker'
import { BaseDisbursementLineOverviewProps, useItemStyles } from './BaseDisbursementOverview'
import FormattedDate from '../../components/Date/FormattedDate'
import { useOverviewStyles } from '../BaseOverview/BaseOverview'

function TurnoverField(props: BaseDisbursementLineOverviewProps) {
    const { t: translate } = useTranslation()

    return (
        <Tooltip
            relationship={'label'}
            content={
                <div>
                    <div>
                        {translate('registration.rate')}: <MoneyText value={props.item.rate} inline />
                    </div>
                </div>
            }
            withArrow
        >
            <div>
                {/*Apply a diff as the Tooltip needs a html component other than span.*/}
                <MoneyText value={props.item.turnover} align="right" />
            </div>
        </Tooltip>
    )
}

function InvoiceTurnoverField(props: BaseDisbursementLineOverviewProps) {
    const { t: translate } = useTranslation()

    return (
        <Tooltip
            relationship={'label'}
            content={
                <>
                    <div>
                        {translate('invoice.edit.form.header.number')}: {props.item.invoice.number}
                    </div>
                    <div>
                        {translate('invoice.status.label')}: {translate(InvoiceStatusLabels.get(props.item.invoice.status).name, { count: 0 })}
                    </div>
                </>
            }
            withArrow
        >
            <Link to={`/invoice/${props.item.invoice.id}/edit`}>
                <MoneyText value={props.item.invoiceTurnover} align="right" />
            </Link>
        </Tooltip>
    )
}

export default function DisbursementListItem(props: BaseDisbursementLineOverviewProps) {
    const itemStyles = useItemStyles()
    const overviewStyles = useOverviewStyles()
    const { viewport, isViewport } = useViewport()

    const listItemSmall = useMemo<boolean>(() => isViewport('<', Viewport.XL), [viewport])

    if (listItemSmall) {
        return (
            <>
                {props.onItemSelected && (
                    <Checkbox
                        className={overviewStyles.centerItems}
                        checked={props.isItemSelected?.(props.item)}
                        disabled={!props.isItemSelectable?.(props.item)}
                        onChange={(_, data) => props.onItemSelected(data, props.item)}
                    />
                )}
                <PersonAvatar name={props.item.user.fullName} color={'colorful'} size={24} />
                {props.renderLink !== false ? (
                    <Link key={props.item.id} to={`${props.baseUrl}/${props.item.id}/edit`}>
                        <Tooltip relationship={'label'} content={props.item.description} withArrow>
                            <Text className={itemStyles.listDisbursementItemOverflow}>{props.item.description}</Text>
                        </Tooltip>
                    </Link>
                ) : (
                    <Tooltip relationship={'label'} content={props.item.description} withArrow>
                        <Text className={itemStyles.listDisbursementItemOverflow}>{props.item.description}</Text>
                    </Tooltip>
                )}
                {props.onItemSelected && <div></div>}
                <div>
                    <FormattedDate date={props.item.date} format={DateFormats.Full} />
                </div>
                <div className={itemStyles.listDisbursementItemSmallBottomRow}>
                    {!props.hideFileField ? (
                        <Tooltip relationship={'label'} content={props.item.file.name} withArrow>
                            <Link key={props.item.id} to={`/file/${props.item.file.id}`}>
                                <Text size={200}>{props.item.file.reference}</Text>
                            </Link>
                        </Tooltip>
                    ) : (
                        <div></div>
                    )}
                    <TurnoverField {...props} />
                    {!props.hideInvoiceField && props.item.invoice && <InvoiceTurnoverField {...props} />}
                    {!props.hideInvoiceField && !props.item.invoice && <div></div>}
                </div>
            </>
        )
    }

    return (
        <>
            {props.onItemSelected && (
                <Checkbox
                    className={overviewStyles.centerItems}
                    checked={props.isItemSelected?.(props.item)}
                    disabled={!props.isItemSelectable?.(props.item)}
                    onChange={(_, data) => props.onItemSelected(data, props.item)}
                />
            )}
            <PersonAvatar name={props.item.user.fullName} color={'colorful'} size={24} />
            <div>
                <FormattedDate date={props.item.date} format={DateFormats.Full} />
            </div>
            {props.renderLink !== false ? (
                <Link key={props.item.id} to={`${props.baseUrl}/${props.item.id}/edit`}>
                    <Tooltip relationship={'label'} content={props.item.description} withArrow>
                        <Text className={itemStyles.listDisbursementItemOverflow}>{props.item.description}</Text>
                    </Tooltip>
                </Link>
            ) : (
                <Tooltip relationship={'label'} content={props.item.description} withArrow>
                    <Text className={itemStyles.listDisbursementItemOverflow}>{props.item.description}</Text>
                </Tooltip>
            )}
            {!props.hideFileField ? (
                <Tooltip relationship={'label'} content={props.item.file.name} withArrow>
                    <Link key={props.item.id} to={`/file/${props.item.file.id}`}>
                        <Text size={200}>{props.item.file.reference}</Text>
                    </Link>
                </Tooltip>
            ) : (
                <div></div>
            )}
            <TurnoverField {...props} />
            {!props.hideInvoiceField && props.item.invoice && <InvoiceTurnoverField {...props} />}
            {!props.hideInvoiceField && !props.item.invoice && <div></div>}
        </>
    )
}
